import axios from "axios";

import { serializeArrayAndFilterNullable } from "utils/queryUtils";

import { type IPeopleDataService } from "./IPeopleDataService";
import type { GetPagedDataRequestV2 } from "../../../interfaces/getPagedDataRequest";
import { isEmpty } from "lodash";

export const peopleDataService: IPeopleDataService = {
  getContent(
    entityId: number,
    peopleType: "groups" | "users",
    type: string,
    request: GetPagedDataRequestV2,
    signal?: AbortSignal,
  ) {
    return axios.get(`/api/${peopleType}/${entityId}/content`, {
      params: {
        ...request,
        term: !isEmpty(request.term) ? request.term : undefined,
        showPurshased: true,
        contentType: type,
      },
      paramsSerializer: serializeArrayAndFilterNullable,
      signal,
    });
  },

  getFlows(entityId: number, peopleType: "groups" | "users", request: GetPagedDataRequestV2, signal?: AbortSignal) {
    return axios.get(`/api/v4/${peopleType}/${entityId}/flows?showPurchased=true`, {
      params: { ...request, term: !isEmpty(request.term) ? request.term : undefined },
      paramsSerializer: serializeArrayAndFilterNullable,
      signal,
    });
  },

  getSchedules(groupId: number, request: GetPagedDataRequestV2, signal?: AbortSignal) {
    return axios.get(`/api/groups/${groupId}/schedules`, {
      params: { ...request, term: !isEmpty(request.term) ? request.term : undefined },
      paramsSerializer: serializeArrayAndFilterNullable,
      signal,
    });
  },
};

export default peopleDataService;
